<button mat-icon-button class="dialog-close-btn" (click)="onDismiss()"><mat-icon>close</mat-icon></button>
<h1 mat-dialog-title>
    Email
</h1>
<div mat-dialog-content>
    <mat-form-field appearance="outline" class="w-100 mt-2">
        <mat-label>Subject</mat-label>
        <input matInput placeholder="Subject" name="subject" [(ngModel)]="email.subject" required>
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100">
        <mat-label>Message</mat-label>
        <textarea matInput placeholder="Message" name="message" rows="6" [(ngModel)]="email.message" required></textarea>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-flat-button color="primary" (click)="onSubmit()" class="border-primary rounded-pill">Submit</button>
</div>
